import styled from 'styled-components';

import { BREAKPOINTS, transitionAnimation } from './../../core';
import { NAVIGATION_WIDTHS } from '../constants';

const SideContentWrapper = styled.div`
  ${transitionAnimation('margin-left')};
  box-sizing: border-box;
  margin-left: ${NAVIGATION_WIDTHS.COLLAPSED};

  @media ${BREAKPOINTS.L} {
    margin-left: ${({ isNavigationCollapsed }) =>
      isNavigationCollapsed ? NAVIGATION_WIDTHS.COLLAPSED : NAVIGATION_WIDTHS.EXPANDED};
  }
`;

export { SideContentWrapper };
